import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import claimScoreApiServiceClient, {
  createClaimScoreApiClient,
} from './client';
import { ClaimScoreApiVersion } from './types';

export {
  CLAIMSCORE_API_URL,
  getAuthorizationToken,
  getBaseURLWithVersion,
} from './clientHelpers';

const versionedClientCache = new Map<ClaimScoreApiVersion, AxiosInstance>();
const UNAUTHORIZED = 401;

export const getClientForVersion = (
  version?: ClaimScoreApiVersion | null,
): AxiosInstance => {
  if (version === null) {
    return createClaimScoreApiClient(null);
  }

  if (!version) {
    return claimScoreApiServiceClient;
  }

  const cached = versionedClientCache.get(version);
  if (cached) {
    return cached;
  }

  const client = createClaimScoreApiClient(version);
  versionedClientCache.set(version, client);
  return client;
};

export function isSessionExpired(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== UNAUTHORIZED) {
    return false;
  }
  const body = error.response?.data as { error?: string } | undefined;
  return body?.error === 'Session expired or invalid';
}

export function isRefreshRequest(config: InternalAxiosRequestConfig): boolean {
  return config.url?.startsWith('/auth/') ?? false;
}
